import styled, { css } from 'styled-components';

type Props = {
  size: string;
  divided?: boolean;
};

const BlockContainer = styled.div(
  ({ theme }) => css`
    display: grid;
    grid-gap: 40px;
    grid-template-columns: 1fr 1fr;

    @media (max-width: ${theme.breakpoints.max.md}) {
      grid-gap: 30px;
    }

    @media (max-width: ${theme.breakpoints.max.sm}) {
      grid-gap: 20px;
    }

    @media (max-width: ${theme.breakpoints.max.xs}) {
      grid-gap: 1.25rem;
    }
  `
);

const Block = styled.div<Props>(
  ({ theme, size, divided }) => css`
    background-color: ${theme.colors.white};
    padding: 30px 40px;
    grid-column: ${size === 'half' ? 'span 1' : 'span 2'};

    @media (max-width: ${theme.breakpoints.max.sm}) {
      padding: 30px;
    }

    @media (max-width: ${theme.breakpoints.max.xs}) {
      padding: 1.875rem;
    }

    ${divided &&
    css`
      > *:not(:first-child) {
        border-top: 1px solid ${theme.colors.black};
        margin-top: ${theme.margins.md};
        padding-top: ${theme.margins.md};
      }
    `}
  `
);

export { Block, BlockContainer };
